import { client } from "@/config/client"

export function deleteTheme(themeId: string) {
  return client.del(`/v1/learning-paths/themes/${themeId}`)
}
